<template>
    <div>
        <slot
            :user="user"
        />
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from 'vue-class-component';
import axios from 'axios';

const UserFillProps = Vue.extend({
    props: {
        baseURL: {
            type: String,
            required: true
        }
    }
})

@Component
export default class UserFill extends UserFillProps {
    public user = false;
    
    mounted() {
        axios({
            method: 'GET',
            url: '/user/api/me',
            baseURL: this.baseURL,
        })
            .then((response) => {
                this.user = response.data;
            });
    }
}

</script>
